<template>
  <div id="app">
    <div
      class="flex flex-wrap -mx-px overflow-hidden sm:-mx-px md:-mx-px lg:-mx-px xl:-mx-px"
    >
      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->
        <h1>LOFI KIMCHI</h1>
        <hr />
      </div>
    </div>
    <div
      class="flex flex-wrap -mx-px overflow-hidden sm:-mx-px md:-mx-px lg:-mx-px xl:-mx-px"
    >
      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->
        <h2 class="gapattop">PREVIEW</h2>
      </div>
    </div>
    <div
      class="flex flex-wrap -mx-px overflow-hidden sm:-mx-px md:-mx-px lg:-mx-px xl:-mx-px"
    >
      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px sm:w-1/3 md:my-px md:px-px md:w-1/3 lg:my-px lg:px-px lg:w-1/3 xl:my-px xl:px-px xl:w-1/3"
      >
        <!-- Column Content -->
        <aplayer
          
          :music="{
            title: 'Sunny Evening [We can all be happy]',
            artist: 'Lofi Kimchi',
            src:
              'https://s3.amazonaws.com/audio.distrokid.com/preview_13714685_9ED85794-2531-4885-BF6ED50B24C95001.mp3',
            pic: require('@/assets/sunnycoversmall.png'),
          }"
        />
        <a
          href="https://distrokid.com/hyperfollow/lofikimchi/sunny-evening-we-can-all-be-happy"
          target="_blank"
          >more...</a
        >
      </div>

      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px sm:w-1/3 md:my-px md:px-px md:w-1/3 lg:my-px lg:px-px lg:w-1/3 xl:my-px xl:px-px xl:w-1/3"
      >
        <!-- Column Content -->
        <aplayer
          :music="{
            title: 'Sleeping',
            artist: 'Lofi Kimchi',
            src:
              'https://s3.amazonaws.com/audio.distrokid.com/preview_13801520_C67E2A3E-75BC-469F-A3C08F1CEB1B77CF.mp3',
            pic: require('@/assets/sleepingcoversmall.png'),
          }"
        />
        <a
          href="https://distrokid.com/hyperfollow/lofikimchi/sleeping"
          target="_blank"
          >more...</a
        >
      </div>

      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px sm:w-1/3 md:my-px md:px-px md:w-1/3 lg:my-px lg:px-px lg:w-1/3 xl:my-px xl:px-px xl:w-1/3"
      >
        <!-- Column Content -->
        <aplayer
          :music="{
            title: 'Saturday Afternon',
            artist: 'Lofi Kimchi',
            src:
              'https://s3.amazonaws.com/audio.distrokid.com/preview_13896653_A1EC294F-3A8E-498E-9DE70A12895CE5EF.mp3',
            pic: require('@/assets/saturdayafternooncoversmall.png'),
          }"
        />
        <a
          href="https://distrokid.com/hyperfollow/lofikimchi/saturday-afternoon"
          target="_blank"
          >more...</a
        >
      </div>
    </div>
	<div
      class="flex flex-wrap -mx-px overflow-hidden sm:-mx-px md:-mx-px lg:-mx-px xl:-mx-px"
    >
      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px sm:w-1/3 md:my-px md:px-px md:w-1/3 lg:my-px lg:px-px lg:w-1/3 xl:my-px xl:px-px xl:w-1/3"
      >
        <!-- Column Content -->
        <aplayer
          
          :music="{
            title: 'The Last Tube',
            artist: 'Lofi Kimchi',
            src:
              'https://s3.amazonaws.com/audio.distrokid.com/preview_13996715_BC6B914B-F3CC-4A00-AC0AE3EF9772B686.mp3',
            pic: require('@/assets/thelasttubecoversmall.png'),
          }"
        />
        <a
          href="https://distrokid.com/hyperfollow/lofikimchi/the-last-tube"
          target="_blank"
          >more...</a
        >
      </div>

      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px sm:w-1/3 md:my-px md:px-px md:w-1/3 lg:my-px lg:px-px lg:w-1/3 xl:my-px xl:px-px xl:w-1/3"
      >
        <!-- Column Content -->
        <aplayer
          :music="{
            title: 'Short Term Objective',
            artist: 'Lofi Kimchi',
            src:
              'https://s3.amazonaws.com/audio.distrokid.com/preview_14159955_6DB9D239-65B2-43C2-9B577E64FF57515C.mp3',
            pic: require('@/assets/shorttermobjectivecoversmall.png'),
          }"
        />
        <a
          href="https://distrokid.com/hyperfollow/lofikimchi/short-term-objective"
          target="_blank"
          >more...</a
        >
      </div>


    </div>
    <hr />
    <div
      class="flex flex-wrap -mx-px overflow-hidden sm:-mx-px md:-mx-px lg:-mx-px xl:-mx-px"
    >
      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->
        <h2 class="gapattop">LISTEN</h2>
      </div>
    </div>
    <div
      class="flex flex-wrap -mx-3 overflow-hidden sm:-mx-px md:-mx-px lg:-mx-px xl:-mx-px"
    >
      <div
        class="my-3 px-3 w-1/2 overflow-hidden sm:my-px sm:px-px sm:w-1/2 md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <iframe
          src="https://open.spotify.com/follow/1/?uri=spotify:artist:6KCAAndkJqljFq3RADyd9c&size=detail&theme=light"
          width="300"
          height="56"
          scrolling="no"
          frameborder="0"
          style="border:none; overflow:hidden;"
          allowtransparency="true"
        ></iframe>
      </div>

      <div
        class="my-3 px-3 w-1/2 overflow-hidden sm:my-px sm:px-px sm:w-1/2 md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->
        <a
          href="https://music.apple.com/gb/artist/lofi-kimchi/1516196168"
          target="_blank"
        >
          <img src="@/assets/Apple Music.svg" class="followicon" />
        </a>
      </div>

      <div
        class="my-3 px-3 w-1/2 overflow-hidden sm:my-px sm:px-px sm:w-1/2 md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->
        <a
          href="https://music.apple.com/us/artist/lofi-kimchi/1516196168"
          target="_blank"
        >
          <img src="@/assets/iTunes.svg" class="followicon" />
        </a>
      </div>

      <div
        class="my-3 px-3 w-1/2 overflow-hidden sm:my-px sm:px-px sm:w-1/2 md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->

        <a href="https://www.deezer.com/en/artist/96491212" target="_blank">
          <img src="@/assets/Deezer.svg" class="followicon" />
        </a>
      </div>

      <div
        class="my-3 px-3 w-1/2 overflow-hidden sm:my-px sm:px-px sm:w-1/2 md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->
        <a
          href="https://play.google.com/store/music/artist?id=Aktsf74xppsblra6clpvazaf2eu"
          target="_blank"
        >
          <img src="@/assets/Google Play.svg" class="followicon" />
        </a>
      </div>
      <div
        class="my-3 px-3 w-1/2 overflow-hidden sm:my-px sm:px-px sm:w-1/2 md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->
        <a
          href="https://www.youtube.com/channel/UC2GIajWlyoBSLpuZ5Z24kYw"
          target="_blank"
        >
          <svg
            class="followicon"
            viewBox="0 0 380.9 85.1"
            preserveAspectRatio="xMidYMid meet"
            fill
          >
            <path
              d="M118.9,13.5c-1.4-5.2-5.5-9.3-10.7-10.7c-9.5-2.5-47.5-2.5-47.5-2.5s-38,0-47.5,2.5C8,4.2,3.9,8.3,2.5,13.5   C0,23,0,42.7,0,42.7s0,19.8,2.5,29.2c1.4,5.2,5.5,9.3,10.7,10.7c9.5,2.5,47.5,2.5,47.5,2.5s38,0,47.5-2.5   c5.2-1.4,9.3-5.5,10.7-10.7c2.5-9.5,2.5-29.2,2.5-29.2S121.4,23,118.9,13.5z"
              fill="#FF0000"
            />
            <polygon fill="#FFFFFF" points="48.5,61 80.1,42.8 48.5,24.5  " />
            <path
              d="M147.1,55.5L133.5,6.2h11.9l4.8,22.3c1.2,5.5,2.1,10.2,2.7,14.1h0.3c0.4-2.8,1.3-7.4,2.7-14l5-22.4h11.9    L159,55.5v23.7h-11.8L147.1,55.5L147.1,55.5z"
            />
            <path
              d="M176.3,77.6c-2.4-1.6-4.1-4.1-5.1-7.6c-1-3.4-1.5-8-1.5-13.6v-7.7c0-5.7,0.6-10.3,1.7-13.8    c1.2-3.5,3-6,5.4-7.6c2.5-1.6,5.7-2.4,9.7-2.4c3.9,0,7.1,0.8,9.5,2.4s4.1,4.2,5.2,7.6s1.7,8,1.7,13.8v7.7c0,5.7-0.5,10.2-1.6,13.7    c-1.1,3.4-2.8,6-5.2,7.6c-2.4,1.6-5.7,2.4-9.8,2.4C182,80,178.7,79.2,176.3,77.6z M189.8,69.3c0.7-1.7,1-4.6,1-8.5V44.2    c0-3.8-0.3-6.6-1-8.4s-1.8-2.6-3.5-2.6c-1.6,0-2.8,0.9-3.4,2.6c-0.7,1.8-1,4.6-1,8.4v16.6c0,3.9,0.3,6.8,1,8.5    c0.6,1.7,1.8,2.6,3.5,2.6C187.9,71.9,189.1,71,189.8,69.3z"
            />
            <path
              d="M241.5,25.9v53.3h-9.4l-1-6.5h-0.3c-2.5,4.9-6.4,7.4-11.5,7.4c-3.5,0-6.1-1.2-7.8-3.5    c-1.7-2.3-2.5-5.9-2.5-10.9V25.9h12V65c0,2.4,0.3,4.1,0.8,5.1s1.4,1.5,2.6,1.5c1,0,2-0.3,3-1c1-0.6,1.7-1.4,2.1-2.4V25.9H241.5z"
            />
            <path d="M274.1,15.9h-11.9v63.3h-11.7V16h-11.9V6.4h35.5V15.9z" />
            <path
              d="M303,25.9v53.3h-9.4l-1-6.5h-0.3c-2.5,4.9-6.4,7.4-11.5,7.4c-3.5,0-6.1-1.2-7.8-3.5    c-1.7-2.3-2.5-5.9-2.5-10.9V25.9h12V65c0,2.4,0.3,4.1,0.8,5.1s1.4,1.5,2.6,1.5c1,0,2-0.3,3-1c1-0.6,1.7-1.4,2.1-2.4V25.9H303z"
            />
            <path
              d="M342.7,34.4c-0.7-3.4-1.9-5.8-3.5-7.3s-3.9-2.3-6.7-2.3c-2.2,0-4.3,0.6-6.2,1.9c-1.9,1.2-3.4,2.9-4.4,4.9    h-0.1V3.5h-11.6v75.7h9.9l1.2-5h0.3c0.9,1.8,2.3,3.2,4.2,4.3c1.9,1,3.9,1.6,6.2,1.6c4.1,0,7-1.9,8.9-5.6c1.9-3.7,2.9-9.6,2.9-17.5    v-8.4C343.8,42.4,343.4,37.8,342.7,34.4z M331.7,56.1c0,3.9-0.2,6.9-0.5,9.1c-0.3,2.2-0.9,3.8-1.6,4.7c-0.8,0.9-1.8,1.4-3,1.4    c-1,0-1.9-0.2-2.7-0.7c-0.8-0.5-1.5-1.2-2-2.1V38.3c0.4-1.4,1.1-2.6,2.1-3.6c1-0.9,2.1-1.4,3.2-1.4c1.2,0,2.2,0.5,2.8,1.4    c0.7,1,1.1,2.6,1.4,4.8c0.3,2.3,0.4,5.5,0.4,9.6L331.7,56.1L331.7,56.1z"
            />
            <path
              d="M360.8,56.5v2.7c0,3.4,0.1,6,0.3,7.7c0.2,1.7,0.6,3,1.3,3.7c0.6,0.8,1.6,1.2,3,1.2c1.8,0,3-0.7,3.7-2.1    c0.7-1.4,1-3.7,1.1-7l10.3,0.6c0.1,0.5,0.1,1.1,0.1,1.9c0,4.9-1.3,8.6-4,11s-6.5,3.6-11.4,3.6c-5.9,0-10-1.9-12.4-5.6    c-2.4-3.7-3.6-9.4-3.6-17.2v-9.3c0-8,1.2-13.8,3.7-17.5s6.7-5.5,12.6-5.5c4.1,0,7.3,0.8,9.5,2.3s3.7,3.9,4.6,7    c0.9,3.2,1.3,7.6,1.3,13.2v9.1h-20.1V56.5z M362.3,34.1c-0.6,0.8-1,2-1.2,3.7s-0.3,4.3-0.3,7.8v3.8h8.8v-3.8c0-3.4-0.1-6-0.3-7.8    c-0.2-1.8-0.7-3-1.3-3.7c-0.6-0.7-1.6-1.1-2.8-1.1C363.9,33,362.9,33.4,362.3,34.1z"
            />
          </svg>
        </a>
      </div>
    </div>
    <hr />
    <div
      class="flex flex-wrap -mx-px overflow-hidden sm:-mx-px md:-mx-px lg:-mx-px xl:-mx-px"
    >
      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->
        <h2 class="gapattop">WATCH</h2>
      </div>
    </div>
    <div
      class="flex flex-wrap -mx-px overflow-hidden sm:-mx-px md:-mx-px lg:-mx-px xl:-mx-px"
    >
      <div
        class="my-px px-px w-full overflow-hidden sm:my-px sm:px-px md:my-px md:px-px lg:my-px lg:px-px xl:my-px xl:px-px"
      >
        <!-- Column Content -->

        <hr />
        <iframe
          src="https://www.youtube.com/embed/r2KvTMPwPVY"
          frameborder="0"
          allow="encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Aplayer from "vue-aplayer";

export default {
  name: "App",
  components: {
    Aplayer,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 10px;
}

.gapattop {
  margin-top: 10px;
}

.followicon {
  height: 40px;
  max-width: 135px;
}
</style>
